import { AxiosInstance } from 'axios';
import {
  IAnalysisSetComparisonFilters,
  IAnalysisSetComparisonResult,
} from '@/types/AnalysisSetComparison/AnalysisSetComparison.types';

export interface IComparisonClient {
  getAnalysisSetComparison: (
    filters: IAnalysisSetComparisonFilters,
  ) => Promise<IAnalysisSetComparisonResult[]>;
}

export function createComparisonClient(instance: AxiosInstance): IComparisonClient {
  async function getAnalysisSetComparison(
    filters: IAnalysisSetComparisonFilters,
  ): Promise<IAnalysisSetComparisonResult[]> {
    const resp = await instance.post<IAnalysisSetComparisonResult[]>('/curation/comparison', filters);
    return resp.data;
  }

  return {
    getAnalysisSetComparison,
  };
}
